module.exports = __webpack_public_path__ + "img/available-courrier.9bf725a0.svg";